import { PlaceholdersId, TFComponent } from '@types';
import { ChangeEmailPlaceholder } from './changeEmail';

export const changeEmail: TFComponent = {
	component: ChangeEmailPlaceholder,
	id: PlaceholdersId.changeEmail,
	name: 'changeEmail',
};
